module.exports = __webpack_public_path__ + "ro.3f922c052c2726fa4f5d.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/ro.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/ro.svg
// module chunks = styles